import { render, staticRenderFns } from "./DeleteKPIModal.vue?vue&type=template&id=5561b572&"
import script from "./DeleteKPIModal.vue?vue&type=script&lang=js&"
export * from "./DeleteKPIModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports